import { Box, Grid, Skeleton } from "@mui/material";
import { BodyLarge, H8TitleMedium, H9TitleSmall } from "../../../components/StyledComponents/Typography/Typography.tsx";
import React from "react";
import { StyledIconButton } from "../../../components/StyledComponents/Buttons/AuradineButtons.js";
import { env } from "../../../env.js";
import useAppContextProvider from "../../../AppContext/useAppContextProvider";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Avatar from "@mui/material/Avatar";
import { userRolesMap } from "../../../constants.js"
import { UserProfileCardLoadingContainer } from "./UserProfileCardLoading.js"
import { postAPIKeyForUser } from "../../../api/api.js";
import { StyledDialog } from "../../../components/StyledComponents/Dialog/Dialog";
import EditProfileDialog from "../EditProfileDIalog/EditProfileDialog";
import { useTheme } from "../../../ThemeContext/ThemeContext.js";

const UserProfileCard = (props) => {
    const { userData, isFetched, isLoading, isFetching, refetch } = props;
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const { colors } = useTheme();


    return (
        <>
            {isFetched && <Grid
                container
                spacing={0}
                className={"content-container"} d
                padding={"2rem"}
                border={"1px solid " + colors?.border?.default}
                borderRadius={"1.5rem"}
            >
                <Grid item xs={5.75}>
                    <Box
                        display={"flex"}
                        flexDirection={"column"}
                        justifyContent={"flex-start"}
                        gap={6}
                    >
                        <Box
                            display={"flex"}
                            flexDirection={"row"}
                            justifyContent={"flex-start"}
                        >
                            <H8TitleMedium>Basic info</H8TitleMedium>
                        </Box>
                        <Box>
                            <Grid container spacing={6}>
                                <Grid item sm={2} xs={12}>
                                    <Avatar
                                        alt={`${userData?.user?.name}`}

                                        src="/static/images/avatar/1.jpg"
                                        sx={{ width: 40, height: 40, bgcolor: colors?.primary?.main }}
                                    >{userData?.user?.name.substring(0, 1)} </Avatar>
                                </Grid>
                                <Grid item xs={10}>
                                    <Box
                                        display={"flex"}
                                        flexDirection={"column"}
                                        justifyContent={"flex-start"}
                                        gap={4}
                                    >
                                        <Grid container display={"flex"} flexDirection={"row"} alignItems={"flex-start"}>
                                            <Grid item sm={3} xs={12} > <H9TitleSmall>Name</H9TitleSmall> </Grid>
                                            <Grid item xs={12} sm={9} sx={{ pr: "2rem" }} ><BodyLarge sx={{whiteSpace: "normal", wordBreak: "break-word", overflowWrap: "break-word"}}>{userData?.user?.name}</BodyLarge> </Grid>
                                        </Grid>
                                        <Grid container display={"flex"} flexDirection={"row"} alignItems={"center"}>
                                            <Grid item sm={3} xs={12}> <H9TitleSmall>Role</H9TitleSmall> </Grid>
                                            <Grid item xs={12} sm={9}> <BodyLarge>{userRolesMap[userData?.user?.role]}</BodyLarge></Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box >
                </Grid >
                <Grid item xs={5.75}>
                    <Box
                        display={"flex"}
                        flexDirection={"column"}
                        justifyContent={"flex-start"}
                        gap={6}
                    >
                        <Box
                            display={"flex"}
                            flexDirection={"row"}
                            justifyContent={"flex-start"}
                        >
                            <H8TitleMedium>Contact info</H8TitleMedium>
                        </Box>
                        <Box>
                            <Grid container >
                                <Grid item xs={12}>
                                    <Box
                                        display={"flex"}
                                        flexDirection={"column"}
                                        justifyContent={"flex-start"}
                                        gap={4}
                                        flexGrow={1}
                                    >
                                        <Grid container display={"flex"} flexDirection={"row"} alignItems={"flex-start"} flexGrow={1} width={"100%"}>
                                            <Grid item sm={3} xs={12}>
                                                <H9TitleSmall>Address</H9TitleSmall>
                                            </Grid>
                                            <Grid item xs={12} sm={9} sx={{ pr: "2rem" }} >
                                                <BodyLarge sx={{whiteSpace: "normal", wordBreak: "break-word", overflowWrap: "break-word"}}>{userData?.user?.address ? userData?.user?.address : "N/A"}</BodyLarge>
                                            </Grid>
                                        </Grid>
                                        <Grid container display={"flex"} flexDirection={"row"} alignItems={"center"}>
                                            <Grid item sm={3} xs={12}>
                                                <H9TitleSmall>Phone</H9TitleSmall>
                                            </Grid>
                                            <Grid item xs={12} sm={9}>
                                                <BodyLarge>{userData?.user?.phone ? userData?.user?.phone : "N/A"}</BodyLarge>
                                            </Grid>
                                        </Grid>
                                        <Grid container display={"flex"} flexDirection={"row"} alignItems={"center"}>
                                            <Grid item sm={3} xs={12}>
                                                <H9TitleSmall>Email</H9TitleSmall>
                                            </Grid>
                                            <Grid item xs={12} sm={7}>
                                                <BodyLarge>{userData?.user?.email}</BodyLarge>
                                            </Grid>
                                            {userData?.user?.invite === "accepted" && (
                                                <Grid item sm={2} xs={12}>
                                                    <Box display={"flex"} justifyContent={"flex-end"}>
                                                        <span className="material-symbols-outlined" style={{ color: colors?.success?.main }}>check_circle</span>
                                                    </Box>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={0.5}>
                    <Box display={"flex"} justifyContent={"flex-end"}>
                        <StyledIconButton  colors={colors} onClick={() => setDialogOpen(true)}>
                            <span className="material-symbols-outlined">edit</span>
                        </StyledIconButton>
                    </Box>
                </Grid>
                <Grid>
                    <EditProfileDialog open={dialogOpen} onClose={() => setDialogOpen(false)} user={userData?.user} refetch={refetch} />

                </Grid>
            </Grid >}
            {(isLoading) && <UserProfileCardLoadingContainer />}
        </>
    );
}

export default UserProfileCard;